import { Space } from 'antd'
import Button from 'app/components/UI-Elements/General/Button'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import { notify } from 'app/lib/Notify'
import * as React from 'react'

const KNotification: React.FC = () => {
  const { toastify, notify: oldNotify } = useFeedbacker()
  return (
    <Space direction="horizontal" wrap>
      <Button onClick={() => toastify({ content: 'error', type: 'error' })}>Open toastify</Button>
      <Button onClick={() => oldNotify({ message: 'error', type: 'error' })}>
        Open old notify
      </Button>
      <Button onClick={() => notify({ message: 'error', intent: 'danger' })}>Open notify</Button>
      <Button
        onClick={() =>
          notify({
            intent: 'success',
            position: 'topRight',
            className: 'success-notification',
            message: 'success',
            additionalOptions: { top: 90, description: 'Any description' }
          })
        }>
        Open Success notify
      </Button>
    </Space>
  )
}

export default KNotification
